module.exports = __webpack_public_path__ + "static/img/Flower3.6899c8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/plants/flowers/Flower3.jpg
// module id = QL3m
// module chunks = 1